const channel = () => {
  const dataMap = {};

  const clearData = (id, data, err) => {
    if (!dataMap[id]) {
      return;
    }

    const {
      reject,
      resolve,
      timeoutID,
    } = dataMap[id];

    if (err) {
      if (typeof err === 'string') {
        reject(new Error(err));
      } else {
        reject(err);
      }
    } else {
      resolve(data);
    }

    delete dataMap[id];
    clearTimeout(timeoutID);
  };

  const addData = ({
    id,
    resolve,
    reject,
    timeout,
  }) => {
    const timeoutID = setTimeout(() => {
      clearData(id, null, new Error('timeout'));
    }, timeout);

    dataMap[id] = {
      resolve,
      reject,
      timeoutID,
    };
  };

  return {
    addData,
    clearData
  };
};

export {
  channel
};
